export default __webpack_public_path__ + "static/media/links_empty_state.3f7be3a5.svg";